import React, { createRef } from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import filter from 'lodash/filter';
import Notice from './Notice';
import { loading } from './Loading';

let seed = 0;

class AlertGroup extends React.Component {
  state = {
    alerts: []
  };

  onEnd = key => {
    const { alerts } = this.state;
    this.setState({
      alerts: filter(alerts, alert => alert.key !== key)
    });
  };

  addAlert = a => {
    if (!a.key) {
      seed++;
      a.key = String(seed);
    }
    this.setState({
      alerts: [a].concat(this.state.alerts)
    });

    return () => this.onEnd(a.key);
  };

  render() {
    const { alerts } = this.state;
    const children = alerts.map(a => {
      return (
        <CSSTransition timeout={500} classNames="item" key={a.key}>
          <div style={{ position: 'relative', transition: 'all .3s linear' }}>
            <Notice {...a} onEnd={() => this.onEnd(a.key)} />
          </div>
        </CSSTransition>
      );
    });

    return <TransitionGroup className="todo-list">{children}</TransitionGroup>;
  }
}

const alertGroup = new Map();

function alert(content, time, type, target = document.body) {
  let group = alertGroup.get(target);
  let cancel = () => {};
  const add = group =>
    group.addAlert({
      content,
      time,
      type
    });

  if (!group) {
    const div = document.createElement('div');

    div.setAttribute('class', 'notice-group');

    // body容器下 默认为fix
    if (target === document.body) {
      div.style.position = 'fixed';
    }

    target.appendChild(div);
    const ref = createRef();
    ReactDOM.render(<AlertGroup ref={ref} />, div, () => {
      group = ref.current;
      alertGroup.set(target, group);
      cancel = add(group);
    });
  } else {
    cancel = add(group);
  }

  return cancel;
}

export default {
  success: (info, time = 3000, target) => alert(info, time, 'success', target),
  error: (info, time = 9000, target) => alert(info, time, 'error', target),
  warning: (info, time = 3000, target) => alert(info, time, 'warning', target),
  loading: (info, time = 0, target) => loading(info, time, 'loading', target)
};
